import { makeStyles } from 'tss-react/mui';

import { pickIf } from '../../../../../utils/pickIf';
import { styleCondition } from '../../../../../utils/styleCondition';

export const useStyles = makeStyles()(
  (theme, { isKiteUser, isDesktopMode, isOutOfStock } = {}) => ({
    ratingContainer: {
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(0.5),
        marginBottom: 0,
      },
    },
    qtyInfo: {
      marginTop: theme.spacing(1),
      marginBottom: 'auto',
      [theme.breakpoints.down('lg')]: {
        marginBottom: 0,
      },
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(0.5),
        marginBottom: 'auto',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginBottom: 0,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginTop: theme.spacing(0.5),
          marginBottom: 'auto',
        }),
      },
    },
    qtyInfoText: {
      fontWeight: '700',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: pickIf(isKiteUser, theme.palette.primary1, theme.palette.pressed),
      '&:nth-child(2)': {
        marginBottom: theme.spacing(0.5),
      },
      [theme.breakpoints.down('lg')]: {
        '&:nth-child(2)': {
          marginBottom: 0,
        },
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '10px',
        lineHeight: '12px',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          '&:nth-child(2)': {
            marginBottom: 0,
          },
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: '10px',
          lineHeight: '12px',
        }),
      },
    },
    outOfStockText: {
      fontWeight: '700',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: '#C5203F',
    },
    productDescription: {
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '700',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      [theme.breakpoints.down('md')]: {
        fontSize: '10px',
        fontWeight: '600',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: '10px',
          fontWeight: '600',
        }),
      },
    },
    sizeVers: {
      [theme.breakpoints.down('md')]: {
        fontSize: '10px',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: '10px',
        }),
      },
    },
    buttonContainer: {
      alignItems: 'end',
      display: 'flex',
      '& > div:nth-child(1)': {
        [theme.breakpoints.down('lg')]: {
          width: 130,
          height: 34,
        },
        [theme.breakpoints.down('md')]: {
          width: 124,
          height: 24,
          marginLeft: 'auto',
          marginRight: 'auto',
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...styleCondition(theme.isMobileDevice, {
            width: 130,
            height: 34,
          }),
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...styleCondition(theme.isMobileDevice, {
            width: 124,
            height: 24,
            marginLeft: 'auto',
            marginRight: 'auto',
          }),
        },
      },
    },
    approvalLabel: {
      position: pickIf(isDesktopMode, 'absolute', 'static'),
      right: pickIf(isDesktopMode && !isOutOfStock, '20px', 'unset'),
      left: pickIf(isDesktopMode && isOutOfStock, '20px', 'unset'),
      bottom: pickIf(isDesktopMode, '14px', 'unset'),
      maxWidth: pickIf(isDesktopMode, '145px', 'unset'),
      marginBottom: pickIf(isDesktopMode, 0, 'auto'),
    },
    totalItems: {
      color: theme.palette.red,
    },
  }),
);
